import gql from 'graphql-tag'

export const GET_INSTRUCTORS_BY_PROGRAM_ID = gql`
  query GetInstructorsByProgramId($query: GetInstructorsByProgramIdInput!) {
    getInstructorsByProgramId(query: $query) {
      instructorInfo {
        Timezone
        TenureWorkExperience
        StartDateWithBerlitz
        SpokenLanguages
        Rating
        Name
        IsPrevious
        IsPreferred
        IsBlocked
        InstructorId
        Gender
        Description
        ContractType
        SortScore
        Specialization
        Avatar
        Video
        SchedulingLevel
        BlockedReason
      }
    }
  }
`
